module.exports = __webpack_public_path__ + "media/images/devices@2x-b51596624922009e3d372745cd29f0a8.png";